import { Controller as BaseController } from "@hotwired/stimulus";
import { Editor } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";

export class Controller extends BaseController {
  static targets = ["input"];

  hideInput() {
    this.inputTarget.hidden = true
  }

  connect() {
    const input = this.inputTarget;
    const classes = input.getAttribute("class");

    this.hideInput = this.hideInput.bind(this)
    document.addEventListener("turbo:morph", this.hideInput)

    this.hideInput()

    this.editor = new Editor({
      element: this.element,
      editorProps: {
        attributes: {
          class: classes,
          "aria-label": input.getAttribute("id"),
          "data-turbo-permanent": true,
        },
      },
      extensions: [
        StarterKit,
        Underline,
        Link.configure({
          protocols: ["http", "https", "mailto", "tel", "ftp"],
          HTMLAttributes: {
            class: "link",
            rel: "noopener noreferrer",
          },
        }),
      ],
      content: input.innerHTML,
      injectCSS: false,
      hideHTMLTags: true,
      type: "HTML",
      onUpdate() {
        input.innerHTML = this.getHTML();
      },
    });
  }

  disconnect() {
    this.editor.destroy()

    document.removeEventListener("turbo:morph", this.hideInput)
  }

  toggleLink() {
    const previousUrl = this.editor.getAttributes("link").href;
    const url = window.prompt("URL", previousUrl);

    if (url === null) {
      return;
    }

    if (url === "") {
      this.editor.chain().focus().extendMarkRange("link").unsetLink().run();
      return;
    }

    try {
      this.editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run();
    } catch (e) {
      alert(e);
    }
  }

  toggleBold() {
    this.editor.chain().focus().toggleBold().run();
  }

  toggleItalics() {
    this.editor.chain().focus().toggleItalic().run();
  }

  toggleUnderline() {
    this.editor.chain().focus().toggleUnderline().run();
  }

  toggleHeadingOne() {
    this.editor.chain().focus().toggleHeading({ level: 1 }).run();
  }

  toggleHeadingTwo() {
    this.editor.chain().focus().toggleHeading({ level: 2 }).run();
  }

  toggleHeadingThree() {
    this.editor.chain().focus().toggleHeading({ level: 3 }).run();
  }

  toggleBulletList() {
    this.editor.chain().focus().toggleBulletList().run();
  }

  toggleOrderedList() {
    this.editor.chain().focus().toggleOrderedList().run();
  }

  toggleHorizontalRule() {
    this.editor.chain().focus().setHorizontalRule().run();
  }

  toggleBlockQuote() {
    this.editor.chain().focus().toggleBlockquote().run();
  }
}
